// Dynamic API Base URL detection
// In development (port 3000): points to backend on port 3001
// In production (Docker Compose, VM, Kubernetes, Ingress): uses "" (relative path)
// All /api/* requests are reverse-proxied internally to the backend.
const getApiBaseUrl = () => {
  // Explicit override via environment variable if provided
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // React local dev server (npm start on port 3000)
  if (typeof window !== 'undefined' && window.location.port === '3000') {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    return `${protocol}//${hostname}:3001`;
  }

  // Production / Deployed environments (Kubernetes, VM, Docker, Ingress):
  // Returns "" so all API calls are relative (/api/...) to the current origin.
  return "";
};

export const API_BASE_URL = getApiBaseUrl();
